module.exports = __webpack_public_path__ + "static/06_peter_erben-7a3f1c892974f7c820dead28d4ad6c9c.jpg";